import { view, lens, lensPath, lensProp, assoc, compose } from 'ramda';
import { typenameLens } from './data';
import mustache from 'mustache';

export const getId = prefix => path => {
  const match = path.match(new RegExp(`${prefix}\/([\\d|\\w|-]*)\/`));
  return match ? match[1] : null;
};

export const isClaimedPromotion = promo =>
  view(typenameLens, promo) === 'ClaimedPromotion';

export const getPromotionId = getId('promotion');
export const getCompanyId = getId('company');
export const getLocationId = getId('location');
export const getEntityId = path =>
  [getCompanyId(path), getLocationId(path)].filter(id => id)[0];
export const getIds = path => [getPromotionId(path), getEntityId(path)];

export const getConfirmationNumber = router =>
  router.currentRoute
    .then(data => data.path.match(/unlocked\/(.*)/)[1])
    .catch(e => null);

export const generateOfferRoute = (state, promotionId, entityType, entityId) =>
  `/promotion/${promotionId}/${entityType}/${entityId}/${state}`;

export const either = (predicate, a, b) => (predicate ? a() : b());
export const when = (predicate, a) => (predicate ? a() : undefined);

function omitTypename(key, value) {
  return key === '__typename' ? undefined : value;
}

export const removeTypename = variables =>
  JSON.parse(JSON.stringify(variables), omitTypename);

export const promoKeysLens = lens(
  promo => {
    if (getHardCodedData(promo).keys) {
      return getHardCodedData(promo).keys;
    }
  },

  promo => promo
);

export const categoriesLens = lens(
  promotion => promotion.categories || [],
  assoc('categories')
);

import { PENSKE_ID, SML_ID, HARD_CODED_DATA } from './constants';

export const getHardcodedId = promotion => {
  if (promotion.name.includes('SML - 10% off moving')) {
    return SML_ID;
  }

  if (
    promotion.metadata &&
    promotion.metadata.url &&
    promotion.metadata.url.includes('pensketruckrental')
  ) {
    return PENSKE_ID;
  }
};

export const getHardCodedData = promotion =>
  HARD_CODED_DATA[getHardcodedId(promotion)] || {};

// Modified from: https://stackoverflow.com/a/24163301
// Modifications:
// - Less capturing groups. Some groups have been made to be noncapturing
// because they simply aren't useful.
// - Allow { and } in querystring. We're using these for templating.
const linkPattern = /(?:<a href=["'])?((?:https?:\/\/)?(?:www\.)?([-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6})\b([-a-zA-Z0-9@:%_+.~#?&//={}]*))(['"]>(.*)<\/a>)?/gi;
export const linkify = (text, data) => {
  if (text && text.replace) {
    const link = text.replace(
      linkPattern,
      (match, fullLink, shortLink, querystring, endOfAnchor, anchorText) =>
        `<a href="${fullLink.replace(
          /\.$/,
          ''
        )}" target="_blank" rel="noopener">${(anchorText || shortLink).replace(
          /\.$/,
          ''
        )}</a>`
    );
    return data ? mustache.render(link, data) : link;
  }

  return text;
};

export const onLinkOut = (element, cb) => {
  const linkClickCallback = event => {
    if (!event.composedPath) return;

    const path = event.composedPath();
    const link = path.find(e => e.tagName === 'A' && e.target === '_blank');

    if (!link) return;

    cb(link);
  };

  element.addEventListener('click', linkClickCallback);
  return () => element.removeEventListener('click', linkClickCallback);
};

// Forked from: https://github.com/sindresorhus/copy-text-to-clipboard
let copyElem;
export const copyTextToClipboard = input => {
  if (!copyElem) {
    copyElem = document.createElement('textarea');
    // Prevent keyboard from showing on mobile
    copyElem.setAttribute('readonly', '');

    copyElem.style.contain = 'strict';
    copyElem.style.position = 'absolute';
    copyElem.style.left = '-9999px';
    copyElem.style.fontSize = '12pt'; // Prevent zooming on iOS
  }

  copyElem.value = input;

  const selection = document.getSelection();
  let originalRange = false;
  if (selection.rangeCount > 0) {
    originalRange = selection.getRangeAt(0);
  }

  document.body.appendChild(copyElem);
  copyElem.select();

  // Explicit selection workaround for iOS
  copyElem.selectionStart = 0;
  copyElem.selectionEnd = input.length;

  let isSuccess = false;
  try {
    isSuccess = document.execCommand('copy');
  } catch (_) {}

  document.body.removeChild(copyElem);

  if (originalRange) {
    selection.removeAllRanges();
    selection.addRange(originalRange);
  }

  return isSuccess;
};
